export default __webpack_public_path__ + "static/media/main_section6.17269593.jpg";